export const useRootDatabase = () => {
  const uds = useDatabaseStore()
  const { apps, customers, users, eventCategories, isDatabaseRootStoreLoaded } = storeToRefs(uds)

  const fetchAndMapData = async (url, transformer) => {
    const { data, promise } = useFetch(`/api/v1/${url}`, null, 'GET')
    await promise
    if (data.value.data) return transformer(data.value.data)
  }

  // Funciones individuales para cada fetch
  const fetchApps = () => {
    return fetchAndMapData('apps', data =>
      data.map(element => ({
        id: element.id,
        value: element.id,
        label: element.name,
        selected: false
      }))
    )
  }
  const fetchEventCategories = () => {
    return fetchAndMapData('event-categories/no-paginate', data =>
      data.map(element => ({
        id: element.id,
        value: element.id,
        text: element.name,
        label: element.name
      }))
    )
  }
  const fetchCustomers = () => {
    return fetchAndMapData('customers/no-paginate', data =>
      data.map(element => ({
        id: element.id,
        value: element.id,
        label: element.name
      }))
    )
  }

  const fetchUsers = () => {
    return fetchAndMapData('users/no-paginate', data => {
      const array = Object.values(data)
      return array.map(element => ({
        id: element.id,
        customer_id: element.customer_id,
        name: `${element.first_name} ${element.family_name}`,
        value: element.id,
        label: `${element.first_name} > ${element.email}`
      }))
    })
  }

  const initializeDatabase = async () => {
    try {
      const [categoriesData, appsData, customersData, usersData] = await Promise.all([
        fetchEventCategories(),
        fetchApps(),
        fetchCustomers(),
        fetchUsers()
      ])
      eventCategories.value = categoriesData
      apps.value = appsData
      customers.value = customersData
      users.value = usersData

      isDatabaseRootStoreLoaded.value = true
    } catch (error) {
      console.error('Error loading database:', error)
      // isDatabaseStoreLoaded.value = false
    }
  }

  return {
    initializeDatabase
  }
}
